module.exports = __webpack_public_path__ + "img/pro-zdTicon14.cc25e433.png";